import { LOG_OUT } from './../../actionTypes';

export function logout() {
  return {
    type: LOG_OUT
  };
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/sync/auth.js